"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useTranslate;

var _react = require("react");

var _i18nContext = _interopRequireDefault(require("./i18n-context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function useTranslate() {
  return (0, _react.useContext)(_i18nContext["default"]);
}